<app-global-spinner></app-global-spinner>
@if (showNavbar) {
	<app-top-navbar></app-top-navbar>
}

<div class="app-shell-content" [class.has-navbar]="showNavbar">
	<router-outlet></router-outlet>
</div>